import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import checkIcon from '../../../../../assets/check.svg';
import logoutIcon from '../../../../../assets/logout.svg';
import addTeamIcon from '../../../../../assets/add-team.svg';
import { format } from 'date-fns';
import DatePicker from './DatePicker/DatePicker';
import GuestSelector from './GuestSelector/GuestSelector';
import { selectInfoSectionStyles } from './SelectInfoSection.styles';
import { getFontSize } from '../../../../../constants/fontSizes';

const SelectInfoSection = () => {
  const [checkInDate, setCheckInDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [guestCount, setGuestCount] = useState(null);
  const [checkOutDatePickerOpen, setCheckOutDatePickerOpen] = useState(false);

  useEffect(() => {
    // When check-in date is selected, open the check-out date picker
    if (checkInDate && !checkOutDate) {
      setCheckOutDatePickerOpen(true);
    }
  }, [checkInDate, checkOutDate]);

  const handleSearch = () => {

    const formattedCheckIn = format(checkInDate, 'yyyy-MM-dd');
    const formattedCheckOut = format(checkOutDate, 'yyyy-MM-dd');

    const params = new URLSearchParams();
    if (guestCount) params.append('minOccupancy', guestCount);
    if(formattedCheckIn) params.append('checkIn', formattedCheckIn);
    if(formattedCheckOut) params.append('checkOut', formattedCheckOut);
    const url = `https://royal-vista.guestybookings.com/en/properties?${params.toString()}`;
    window.open(url, '_blank');
  };

  return (
    <Box sx={selectInfoSectionStyles.container}>
      <DatePicker
        value={checkInDate}
        onChange={setCheckInDate}
        title="Check in"
        icon={
          <Box
            component="img"
            src={checkIcon}
            alt=""
            loading="lazy"
            sx={{ width: getFontSize(24), height: getFontSize(24), objectFit: 'contain' }}
          />
        }
        placeholder="Select date"
      />
      <DatePicker
        value={checkOutDate}
        onChange={setCheckOutDate}
        title="Check out"
        icon={
          <Box
            component="img"
            src={logoutIcon}
            alt=""
            loading="lazy"
            sx={{ width: getFontSize(24), height: getFontSize(24), objectFit: 'contain' }}
          />
        }
        placeholder="Select date"
        open={checkOutDatePickerOpen}
        onOpenChange={setCheckOutDatePickerOpen}
      />
      <GuestSelector
        value={guestCount}
        onChange={setGuestCount}
        title="Who"
        icon={
          <Box
            component="img"
            src={addTeamIcon}
            alt=""
            loading="lazy"
            sx={{ width: getFontSize(24), height: getFontSize(24), objectFit: 'contain' }}
          />
        }
        placeholder="Select"
      />
      <Button
        variant="contained"
        disableElevation
        color="primary"
        onClick={handleSearch}
        sx={selectInfoSectionStyles.searchButton}
      >
        Search
      </Button>
    </Box>
  );
};

export default SelectInfoSection;

